import React from "react";
import Table from "components/TableWrapper/TableWrapper";
import { subscriptionTableColumns } from "./subscriptionTableColumns";
import SubscriptionService from "services/SubscriptionService";
import SubscriptionForm from "components/SubscriptionForm/SubscriptionForm";
import { useSnackbar } from "hooks/useSnackbar";

export default function SubscriptionTable({
    subscriptions,
    isLoading,
    mutate,
    openDialog,
    closeDialog,
}) {
    const openSnackbar = useSnackbar();

    const handleDelete = async (id) => {
        try {
            await SubscriptionService.del(id);
            openSnackbar("success", "Subscription deleted successfully");
            mutate();
        } catch (error) {
            console.error(error);
            openSnackbar("error", "Failed to delete subscription");
        }
    };

    const handleEdit = (row) => {
        openDialog({
            customDialog: true,
            fullWidth: true,
            maxWidth: "xs",
            message: (
                <SubscriptionForm
                    initialValues={row}
                    closeDialog={closeDialog}
                    onSuccess={() => {
                        mutate();
                        closeDialog();
                    }}
                />
            ),
        });
    };

    return (
        <Table
            showEditButton
            showDeleteButton
            columns={subscriptionTableColumns}
            data={subscriptions}
            fetchData={() => {}}
            pageCount={1}
            loading={isLoading}
            onEditClick={handleEdit}
            onDeleteClick={handleDelete}
        />
    );
}
